var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPinUser(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 57,
    viewBox: "0 0 32 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_322_46",
    x: 7,
    y: 46,
    width: 18,
    height: 11,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0509804 0 0 0 0 0.101961 0 0 0 0 0.396078 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_322_46"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_322_46",
    result: "shape"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 16,
    cy: 49.5,
    rx: 5,
    ry: 1.5,
    fill: "black",
    fillOpacity: 0.01,
    filter: "url(#filter0_d_322_46)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 27H17V49.0643L16.0436 50L15 49.0643V27Z",
    fill: "#9896AF"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 19,
    r: 11,
    fill: "#19B457",
    stroke: "white",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4575 19.4958C15.9067 18.685 16.77 18.2067 17.2717 17.4892C17.8025 16.7367 17.505 15.3308 16 15.3308C15.0142 15.3308 14.53 16.0775 14.3258 16.6958L12.815 16.06C13.2292 14.8175 14.355 13.75 15.9942 13.75C17.365 13.75 18.3042 14.3742 18.7825 15.1558C19.1908 15.8267 19.43 17.0808 18.8 18.0142C18.1 19.0467 17.4292 19.3617 17.0675 20.0267C16.9217 20.295 16.8633 20.47 16.8633 21.3333H15.1775C15.1717 20.8783 15.1017 20.1375 15.4575 19.4958ZM17.1667 23.6667C17.1667 24.3083 16.6417 24.8333 16 24.8333C15.3583 24.8333 14.8333 24.3083 14.8333 23.6667C14.8333 23.025 15.3583 22.5 16 22.5C16.6417 22.5 17.1667 23.025 17.1667 23.6667Z",
    fill: "white"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinUser);
export default __webpack_public_path__ + "static/media/pinUser.7fe351c52dbfdb333e16b186d4acdb26.svg";
export { ForwardRef as ReactComponent };